<template>
  <div class="contact-mentor-form" v-if="mentor">
    <b-row class="py-3 border-bottom">
      <b-col cols="12" class="d-flex justify-content-center align-items-center">
        <avatar :user="mentor" :size="72"/>
      </b-col>
      <b-col cols="12" class="pt-3 text-center">
        <b>{{mentor.fullName}}</b><br>
        <span class="text-muted" v-if="jobTitle">{{jobTitle}}</span>
        <span class="text-muted pl-4" v-if="mentor.location">
          <font-awesome-icon icon="map-marker" style="color: #bbb"/> {{mentor.location.name}}
        </span>
      </b-col>
    </b-row>
    <template v-if="!requestSent">
      <b-row>
        <b-col cols="12" class="pt-3 pb-2">
          <b-form-group label="Select which skills you would like to be mentored on:" label-class="pb-0 mb-0">
            <span
              class="skill-tag mr-2 mt-2"
              v-for="skill in skills"
              :style="{ backgroundColor: form.selectedSkills.includes(skill.name) ? selectedSkillBG : skillBG }"
              :key="skill.name"
              @click="toggleSkill(skill.name)"
            >{{ skill.name }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :label="`Write a personal message to ${mentor.firstName} about how you think they can help:`">
            <b-textarea placeholder="Type your message here..." v-model="form.message" rows="4" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col>
          <b-button
            variant="primary"
            class="float-right px-5"
            :disabled="!formValid"
            @click="submitContactMentorRequest"
          >Send Request</b-button>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col cols="12" class="py-4 text-muted text-center">
          Thanks - your message has been sent to {{mentor.firstName}} who will aim to get back to you within 48 hours.
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col>
          <b-button
            variant="primary"
            class="float-right px-5"
            @click="$emit('closeModal')"
          >Done</b-button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import Avatar from '@/components/users/Avatar';

export default {
  components: { Avatar },
  props: {
    mentor: {
      type: Object,
      default: null,
    },
    jobTitle: {
      type: String,
      default: '',
    },
    skills: {
      type: Array,
      default: () => [],
    },
    skillBG: {
      type: String,
      default: '#eee',
    },
    selectedSkillBG: {
      type: String,
      default: '#ccc',
    },
  },
  data: () => ({
    err: null,
    form: {
      selectedSkills: [],
      message: '',
    },
    requestSent: false,
  }),
  computed: {
    isValid() {
      const isValid = {};
      // isValid.selectedSkills = this.form.selectedSkills.length || false;
      isValid.message = this.form.message.length || false;
      return isValid;
    },
    formValid() {
      const { isValid } = this;
      return Object.keys(isValid).reduce((out, key) => out && isValid[key], true);
    },
  },
  methods: {
    toggleSkill(skill) {
      if (!this.form.selectedSkills.includes(skill)) {
        this.form.selectedSkills.push(skill);
      } else {
        this.form.selectedSkills = this.form.selectedSkills.filter(el => el !== skill);
      }
    },
    submitContactMentorRequest() {
      this.$emit('submitContactMentorRequest', this.form);
      this.requestSent = true;
    },
  },
};
</script>

<style lang="scss">
.contact-mentor-form {
  .skill-tag {
    display: inline-block;
    font-size: 13px;
    padding: 3px 6px;
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mentors/ContactMentorForm.vue